import React from 'react';
import { Box,} from '@chakra-ui/react';

const Footer = () => {
  return (
    <Box bg="teal.500" color="white" py={4} textAlign="center">
    </Box>
  );
};

export default Footer;
